export default (state, getters, rootState, rootGetters) => val => {
  let agreement = getters.agreement(val.code);
  let sum = rootState.finances.pay.form.Sum - getters.sum_all;
  if (agreement.currency !== rootState.finances.pay.form.CurrencyId) {
    sum = Math.floor((sum / agreement.course + val.sum) * 100) / 100;
  } else {
    sum = Math.floor((sum + val.sum) * 100) / 100;
  }
  return sum;
}